import React from 'react';
import { Link } from 'react-router-dom';
import ContentContainer from './ContentContainer';
import Cards from '../../../../components/molecules/cards';
import Modal from '../../../../components/organisms/modals';
import { Delete, Pencil as PencilIcon } from '../../../../components/atoms/icons';
import { successUpdateMsg } from '../../../../components/atoms/const';
import dummyClientById from './clientById.json';

interface Props {
    onNavigate: () => void;
    data: typeof dummyClientById.partner | undefined;
    handleDelete: () => void;
    resultDelete: any;
    afterDelete: () => void;
    loadingDelete: boolean;
    clientId: string;
}

function RenderPartners(props: Props) {
  const {
    onNavigate, data, clientId, handleDelete, afterDelete, loadingDelete, resultDelete,
  } = props;

  const renderModalBodyDelete = ():string => {
    if (!resultDelete) return 'Are you sure to remove this Partner?';
    return successUpdateMsg.SUCCESS_DELETE_CLIENT_PARTNER_MSG;
  };

  const onAdd = () => !!data && data.name === 'no-contract';

  return (
    <ContentContainer
      onNavigate={() => {
        if (onAdd()) return onNavigate();
        return document.getElementById('editLink')?.click();
      }}
      buttonWidth={170}
      title="Partners"
      buttonLabel={onAdd() ? '+ Add Partner' : 'Edit Partner'}
    >
      <div>
        {data && data.name !== 'no-contract' && (
        <div className="row">
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-2">
            <Cards.Partner
              id={data.id.toString()}
              name={data.name ?? '-'}
              email={data.address ?? '-'}
              commission={data.comission ?? 0}
              deleteIcon={(
                <Modal.Default
                  cancelLabel="No"
                  submitLabel="Yes"
                  title="Delete Partner"
                  body={renderModalBodyDelete()}
                  size="sm"
                  isLoading={loadingDelete}
                  result={resultDelete}
                  onAfterResult={afterDelete}
                  onSubmit={() => handleDelete()}
                >
                  <Delete width={18} color="black" />
                </Modal.Default>
              )}
              editIcon={(
                <Link id="editLink" to={`/clients/partner/${clientId}/${data.id}`}>
                  <PencilIcon width={20} color="black" />
                </Link>
              )}
            />
          </div>
        </div>
        )}
      </div>
    </ContentContainer>
  );
}

export default RenderPartners;
